document.addEventListener('DOMContentLoaded', () => {
    let currentSlide = 1;

    const sliderNavItems = document.querySelectorAll('.slider__navigation span');
    sliderNavItems.forEach((elem) => {
        elem.addEventListener('click', () => {
            const selectedSlide = parseInt(elem.getAttribute('data-slide'));
            slideToSlide(selectedSlide);
            currentSlide = selectedSlide;
        })
    })

    const slideToSlide = (slide: number) => {
        const currentImage = document.querySelector('.slider__background img.active');
        const currentItem = document.querySelector('.slider__navigation span.active');
        const currentTitle = document.querySelector('.sliderTitle__item.active');

        currentItem.classList.remove('active');
        currentImage.classList.remove('active');
        currentTitle.classList.remove('active');

        document.querySelector(`.slider__background img[data-slide="${slide}"]`).classList.add('active');
        document.querySelector(`.slider__navigation span[data-slide="${slide}"]`).classList.add('active');
        document.querySelector(`.sliderTitle__item[data-slide="${slide}"]`).classList.add('active');
    }
});